__turbopack_context__.v({
  "app_light_theme": "CardModal-module-scss-module__XD0w_G__app_light_theme",
  "cardModalContent": "CardModal-module-scss-module__XD0w_G__cardModalContent",
  "cardModalContent__content": "CardModal-module-scss-module__XD0w_G__cardModalContent__content",
  "cardModalContent__inner": "CardModal-module-scss-module__XD0w_G__cardModalContent__inner",
  "modalContent": "CardModal-module-scss-module__XD0w_G__modalContent",
});
